var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDelBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    fill: "#494edf",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.4,157.1c-3.9,0-7.1-3.2-7.1-7.1V71.4c0-3.9,3.2-7.1,7.1-7.1s7.1,3.2,7.1,7.1V150C128.6,154,125.4,157.1,121.4,157.1 L121.4,157.1z M78.6,157.1c-4,0-7.1-3.2-7.1-7.1V71.4c0-3.9,3.2-7.1,7.1-7.1c3.9,0,7.1,3.2,7.1,7.1V150 C85.7,154,82.5,157.1,78.6,157.1L78.6,157.1z M192.9,35.7h-35.7V21.4c0-11.8-9.5-21.4-21.3-21.4H64.3C52.5,0,42.9,9.6,42.9,21.4 v14.3H7.1c-4,0-7.1,3.2-7.1,7.1C0,46.8,3.2,50,7.1,50h185.7c3.9,0,7.1-3.2,7.1-7.1C200,38.9,196.8,35.7,192.9,35.7L192.9,35.7z  M57.1,21.4c0-3.9,3.2-7.1,7.1-7.1h71.6c3.9,0,7,3.1,7,7.1v14.3H57.1V21.4z M150,200H50c-11.8,0-21.4-9.6-21.4-21.4V71.3 c0-3.9,3.2-7.1,7.1-7.1c3.9,0,7.1,3.2,7.1,7.1v107.3c0,3.9,3.2,7.1,7.1,7.1h100c3.9,0,7.1-3.2,7.1-7.1v-107c0-3.9,3.2-7.1,7.1-7.1 c3.9,0,7.1,3.2,7.1,7.1v107C171.5,190.4,161.8,200,150,200L150,200z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDelBlue);
export default __webpack_public_path__ + "static/media/ico-delBlue.c538f18de239176a0fe1a079764dfec3.svg";
export { ForwardRef as ReactComponent };